// extracted by mini-css-extract-plugin
export default {"menu":"Spreadsheet_menu__SZwBB","item":"Spreadsheet_item__YPtqT","checkboxGroup":"Spreadsheet_checkboxGroup__bARm7"};